export const locale = {
  'DIALOG' : {
    'CREATETYPE' : {
      'TITLE' : {
        'CREATE' : 'Create group',
        'EDIT' : 'Edit group',
      },
      'CONFIRMBUTTON' : {
        'CREATE' : 'Create',
        'SAVE' : 'Save',
      },
      'NAME' : 'Group name',
    },
  },
};
